/**
 * Time-period selector + date formatting for the historical scatter view.
 * Pure helpers — no React or three.js dependencies.
 */

export const TIME_PERIODS = [
  { key: null, label: 'Live' },
  { key: '1d', label: '1D' },
  { key: '1w', label: '1W' },
  { key: '1m', label: '1M' },
  { key: '3m', label: '3M' },
  { key: '6m', label: '6M' },
  { key: '1y', label: '1Y' },
  { key: '2y', label: '2Y' },
] as const

export type TimePeriodKey = typeof TIME_PERIODS[number]['key']

/**
 * Format a YYYY-MM-DD date string as e.g. "April 15, 2026 — 10 days ago".
 * Returns "today" for ≤1 day, day count for <1yr, else year-fraction.
 */
export function formatHistoricalDate(dateStr: string, now: Date = new Date()): string {
  const d = new Date(dateStr + 'T12:00:00Z')
  const diffDays = Math.round((now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24))
  const formatted = d.toLocaleDateString('en-US', {
    month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  })
  if (diffDays <= 1) return `${formatted} — today`
  if (diffDays < 365) return `${formatted} — ${diffDays} days ago`
  const years = Math.round((diffDays / 365) * 10) / 10
  return `${formatted} — ~${years}y ago`
}
